import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from 'react';

import { useDeviceType } from '../hooks';

interface MenuContextType {
  isMenuOpen: boolean;
  setIsMenuOpen: Dispatch<SetStateAction<boolean>>;
}

export const MenuContext = React.createContext<MenuContextType>(
  {} as MenuContextType
);

export const MenuProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const deviceType = useDeviceType();

  useEffect(() => {
    if (deviceType === 'desktop') {
      setIsMenuOpen(false);
    }
  }, [deviceType]);

  const value = useMemo(
    () => ({
      isMenuOpen,
      setIsMenuOpen,
    }),
    [isMenuOpen]
  );

  return (
    <MenuContext.Provider value={value}>
      {children}
    </MenuContext.Provider>
  );
};

export const useMenu = () => React.useContext(MenuContext);
